import { Component, OnInit, inject, viewChild } from '@angular/core';
import { AdvertiserGridComponent } from '../advertiser-grid/advertiser-grid.component';
import { AdvertiserFiltersComponent } from '../advertiser-filters/advertiser-filters.component';
import { IAdvertiserQueryRequestDto } from 'src/app/api/api-campaigns.service.generated';
import { ScreenService } from 'src/app/common/services/screen.service';
import { PERMISSION } from 'src/app/const/permission';
import { HasAnyPermissionDirective } from 'src/app/common/directives/has-any-permission/has-any-permission.directive';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { BreadcrumbsComponent, ButtonComponent, PageContainerComponent } from 'wecheer-common';
import { AppVersionService } from 'src/app/common/services/app-version.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-advertiser-search',
    templateUrl: './advertiser-search.component.html',
    styleUrls: ['./advertiser-search.component.scss'],
    imports: [
      AdvertiserGridComponent,
      AdvertiserFiltersComponent,
      MatMenuModule,
      MatIconModule,
      HasAnyPermissionDirective,
      AsyncPipe,
      PageContainerComponent,
      ButtonComponent,
      BreadcrumbsComponent
    ]
})
export class AdvertiserSearchComponent implements OnInit {
  screen = inject(ScreenService);
  appVersion = inject(AppVersionService);

  readonly filters = viewChild<AdvertiserFiltersComponent>('filters');
  readonly grid = viewChild<AdvertiserGridComponent>('grid');

  readonly permissions = PERMISSION;

  ngOnInit() {
  }

  onSearch(filter: IAdvertiserQueryRequestDto) {
    setTimeout(async () => {
      await this.grid().search(filter);
    });
  }

  async add() {
    await this.grid().onEdit(null);
  }
}
